export const verifyPledging = async (action, _datastore, { navigate, setDatastore, asyncStorage }) => {
    console.warn('****Verify data****');
    // await setDatastore(action.routeId, action.payload.widgetId, <ButtonProps>{
    //   loading: true,
    // });
};
